module.exports = __webpack_public_path__ + "static/media/wifi-level-1-mobile.1c0d5835.svg";